import { render, staticRenderFns } from "./LibraryShare.vue?vue&type=template&id=1bd55988"
import script from "./LibraryShare.vue?vue&type=script&lang=js"
export * from "./LibraryShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports